import script from "./UnreadSmsEmailLogs.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnreadSmsEmailLogs.vue?vue&type=script&lang=ts&setup=true"

import "./UnreadSmsEmailLogs.vue?vue&type=style&index=0&id=1781c5a5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1781c5a5"]])

export default __exports__